import Amplify from 'aws-amplify';

export default function iniciarConfiguracionAPI() {
  Amplify.configure({
    Auth: {
      mandatorySignIn: true,
      region: process.env.REACT_APP_COGNITO_AWS_REGION,
      userPoolId: process.env.REACT_APP_USER_POOL_ID,
      userPoolWebClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
      identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
      oauth: {
        domain: process.env.REACT_APP_COGNITO_DOMAIN,
        redirectSignIn: process.env.REACT_APP_REDIRECT_SIGNIN,
        redirectSignOut: process.env.REACT_APP_REDIRECT_SIGNOUT,
        responseType: "code",
        scope: ["phone", "email", "profile", "openid", "aws.cognito.signin.user.admin"],
      }
    },
    API: {
      endpoints: [
        {
          name: process.env.REACT_APP_API_GATEWAY_NAME,
          endpoint: process.env.REACT_APP_API_GATEWAY_URL,
          region: process.env.REACT_APP_API_GATEWAY_REGION
        },
        {
          name: "API_ROLES",
          endpoint: process.env.REACT_APP_API_ROLE,
          // endpoint: "https://tmqi4iule7.execute-api.us-east-2.amazonaws.com/test",
          region: process.env.REACT_APP_API_GATEWAY_REGION
        }
      ]
    }
  });
}